import { render, staticRenderFns } from "./Memento.vue?vue&type=template&id=17bbc315&"
import script from "./Memento.vue?vue&type=script&lang=js&"
export * from "./Memento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports